(function () {
    'use strict';
    'ngInject';

    angular.module('app.ctrls').controller('TemplateSavedModalCtrl', templateSavedModalCtrl);

    function templateSavedModalCtrl($scope, $mdDialog, $timeout, templateId, user) {
        $scope.templateId = templateId;
        $scope.showCopiedTooltip = false;

        const stores = user.Stores.filter((s) => !s.Disabled);
        $scope.anyShopifyStore = stores.some((s) => s.Type === 1);
        $scope.anyWooStore = stores.some((s) => s.Type === 3);

        $scope.goToStore = function () {
            $mdDialog.hide({
                action: 'save-and-go-to-store'
            });
        };

        $scope.goHome = function () {
            $mdDialog.hide({
                action: 'save'
            });
        };

        $scope.copyTemplateId = function () {
            const textAreaHiddenCopy = document.createElement('textarea');
            textAreaHiddenCopy.value = templateId;
            textAreaHiddenCopy.select();
            document.execCommand('copy');

            $scope.showCopiedTooltip = true;
            $timeout(() => {
                $scope.showCopiedTooltip = false;
            }, 1500);
        };
    }
})();
